'use strict';

export const SHIRTSIZE_DATA = [
    {
        type: 'header',
        cells: [
            "Men Sizes"
        ]
    },
    {
        type: 'legend',
        cells: [
            "Nike Size", "Chest (in.)", "Waist (in.)"
        ]
    },
    {
        type: 'row',
        cells: [
            "Small", "35–37.5", "29–32"
        ]
    },
    {
        type: 'row',
        cells: [
            "Medium", "37.5–41", "32–35"
        ]
    },
    {
        type: 'row',
        cells: [
            "Large", "41–44", "35–38"
        ]
    },
    {
        type: 'row',
        cells: [
            "X–Large", "44–48.5", "38–43"
        ]
    },
    {
        type: 'row',
        cells: [
            "XX–Large", "48.5–53.5", "43–47.5"
        ]
    },
    {
        type: 'row',
        cells: [
            "3XL", "53.5–58", "47.5–52.5"
        ]
    },
    {
        type: 'row',
        cells: [
            "4XL", "58–63", "52.5–57"
        ]
    },
    {
        type: 'header',
        cells: [
            "Women Sizes"
        ]
    },
    {
        type: 'legend',
        cells: [
            "Nike Size", "Size", "Bust (in.)", "Waist (in.)"
        ]
    },
    {
        type: 'row',
        cells: [
            "Small", "4–6", "32.5–35.5", "26–29"
        ]
    },
    {
        type: 'row',
        cells: [
            "Medium", "8–10", "35.5–38", "29–31.5"
        ]
    },
    {
        type: 'row',
        cells: [
            "Large", "12–14", "38–41", "31.5–34.5"
        ]
    },
    {
        type: 'row',
        cells: [
            "X–Large", "16–18", "41–44.5", "34.5–38.5"
        ]
    },
    {
        type: 'row',
        cells: [
            "XX–Large", "20–22", "44.5–48.5", "38.5–42.5"
        ]
    },
];
